import { lazy } from "react";

const MemberReport = lazy(() => import("../../../views/App/Report/MemberReport/index"));
const MemberStatus = lazy(() => import("../../../views/App/Report/MemberStatus/index"));
const NotificationReport = lazy(() => import("../../../views/App/Report/NotificationReport/index"));
const TalentReport = lazy(() => import("../../../views/App/Report/TalentReport/index"));
const FeedbackReport = lazy(() => import("../../../views/App/Report/FeedbackReport/index"));
const UserServices = lazy(() =>
  import("../../../views/App/Report/ServicesReport/index")
);
const WatchTimeReport = lazy(() =>
  import("../../../views/App/Report/WatchTimeReport/index")
);
const ChatSessions = lazy(() =>
  import("../../../views/App/Report/ChatSessionReport/index")
);
export default [
  {
    element: <MemberReport />,
    path: "/Report/MemberReport",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
  {
    element: <MemberStatus />,
    path: "/Report/MemberStatus",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
  {
    element: <NotificationReport />,
    path: "/Report/NotificationReport",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
  {
    element: <TalentReport />,
    path: "/Report/TalentReport",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
  {
    element: <FeedbackReport />,
    path: "/Report/FeedBackReport",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
  {
    element: <WatchTimeReport />,
    path: "/Report/WatchTimeReport",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
  {
    element: <UserServices />,
    path: "/Report/UserServices",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
  {
    element: <ChatSessions />,
    path: "/Report/ChatSessions",

    meta: {
      action: "read",
      resource: "DocType-2",
    },
  },
];
